import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {
  BusinessProfilesHttpService
} from "../../../../../services/http-services/business-profiles/business-profiles-http.service";
import {
  FormControlErrorMessagesModule
} from "../../../../../pipes/form-control-error-messages/form-control-error-messages.module";
import {FormControlModule} from "../../../../../pipes/form-control/form-control.module";

@Component({
  selector: 'app-custom-slot-price',
  templateUrl: './custom-slot-price.component.html',
  imports: [
    DatePipe,
    NgForOf,
    NgIf,
    FormsModule,
    FormControlErrorMessagesModule,
    FormControlModule
  ],
  standalone: true
})
export class CustomSlotPriceComponent implements OnInit {
  @Input() urlParams: any;
  @Input() setCustomSelectedDayData: any = null;
  @Input() daySlots: any;
  @Input() setCustomSelectedDateKey: any;
  @Input() setCustomSelectedDayName: any;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();
  termSelected: any;
  slotSelected: any;

  constructor(
    private businessProfilesHttpService: BusinessProfilesHttpService,
  ) {
  }

  ngOnInit(): void {
    console.log('setCustomSelectedDayData', this.setCustomSelectedDayData)
  }

  onTermSelected(term: any) {
    this.termSelected = term;
    if (this.termSelected.slots) {
      this.termSelected.slots.forEach((slot: any) => {
        slot.tempPrice = slot.override_price !== null ? slot.override_price : slot.price;
      });
    }
  }

  prepareAndSave(termSelected: any, slot: any, novaCena: string, inputElement: HTMLInputElement) {
    console.log('term', termSelected)
    console.log('slot', slot)

    const newPrice = parseFloat(novaCena);
    const payload: any = {
      date: this.setCustomSelectedDateKey,
      price: newPrice,
      is_disabled: false
    };
    if (slot.override && slot.override.id) {
      payload.id = slot.override.id;
    } else {

    }

    const paypay = {
      overrides: [payload]
    };

    const workingDay = this.getDay(this.setCustomSelectedDateKey);

    if (workingDay) {
      this.businessProfilesHttpService.overrideTermTimeslot(
        this.urlParams.companyId,
        workingDay.id,
        termSelected.time_slot_id,
        slot.slot_id,
        paypay
      ).subscribe(res => {
        console.log('Uspešno sačuvano:', res);
        const slotIndex = this.termSelected.slots.findIndex((s: any) => s.slot_id === slot.slot_id);

        if (slotIndex !== -1) {
          const newOverride = res.data ? res.data[0] : res;
          this.termSelected.slots[slotIndex] = {
            ...this.termSelected.slots[slotIndex],
            override: newOverride
          };
          inputElement.value = slot.override.price.toString();
          console.log('termselected afer change', this.termSelected);
        }
      });
    } else {
      console.error('Nije pronađen radni dan za datum:', this.setCustomSelectedDateKey);
    }
  }

  getDay(dateKey: any): any {
    const date = new Date(dateKey);
    let jsDay = date.getDay();
    const weekdayToFind = jsDay === 0 ? 7 : jsDay;
    const selectedWorkDay = this.daySlots.find((wd: any) => wd.weekday === weekdayToFind);
    return selectedWorkDay;
  }

}
